'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItemTitle = exports.ListItemSegment = exports.ListItem = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Flex = require('../Flex');

require('./styles.sass');

var _prefix = require('../../utils/prefix');

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifiers = (0, _prefix2.default)('ListItem--');

/**
 * A list item that looks decent in widgets.
 *
 * @param  {Boolean} options.pad
 * Adds some padding around the entire item
 *
 * @param  {Boolean} options.clickable
 * Adds some styling that indicates that the item is clickable.
 */
var ListItem = function ListItem(_ref) {
  var className = _ref.className,
      border = _ref.border,
      pad = _ref.pad,
      children = _ref.children,
      clickable = _ref.clickable,
      props = (0, _objectWithoutProperties3.default)(_ref, ['className', 'border', 'pad', 'children', 'clickable']);
  return _react2.default.createElement(
    _Flex.FlexContainer,
    (0, _extends3.default)({
      className: (0, _classnames2.default)('ListItem', modifiers({ pad: pad, clickable: clickable, border: border }), className)
    }, props),
    children
  );
};

exports.ListItem = ListItem;
ListItem.propTypes = {
  clickable: _propTypes2.default.bool,
  border: _propTypes2.default.bool,
  pad: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};

/**
 * A segment inside a ListItem - a segment is a flex item that goes from left to right.
 * Additional props are passed to the underlying FlexItem - e.g. `stretch`
 *
 * @param  {Boolean} options.pad
 * Adds padding around this segment. Values are the same as if the list item itself was padded.
 */
var ListItemSegment = function ListItemSegment(_ref2) {
  var className = _ref2.className,
      pad = _ref2.pad,
      children = _ref2.children,
      props = (0, _objectWithoutProperties3.default)(_ref2, ['className', 'pad', 'children']);
  return _react2.default.createElement(
    _Flex.FlexItem,
    (0, _extends3.default)({
      className: (0, _classnames2.default)('ListItemSegment', { 'ListItemSegment--pad': pad }, className)
    }, props),
    children
  );
};

exports.ListItemSegment = ListItemSegment;
ListItemSegment.propTypes = {
  pad: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};

/**
 * A preformatted ListItem title.
 */
var ListItemTitle = exports.ListItemTitle = function ListItemTitle(_ref3) {
  var className = _ref3.className,
      children = _ref3.children;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('ListItemTitle', className) },
    children
  );
};

ListItemTitle.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/ListItem/index.js
// module id = 187
// module chunks = 0